var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQMonitorBlack = function SvgQMonitorBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18.462,
    height: 12.923,
    x: 2.769,
    y: 3,
    fill: "#00081E",
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9B9B9B",
    d: "M9.23 17.03v-1.107h5.54v1.106c0 1.645.853 2.091 1.74 3.355a.098.098 0 0 1-.081.154H7.572a.098.098 0 0 1-.082-.154c.887-1.264 1.74-1.71 1.74-3.355"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00081E",
    fillRule: "evenodd",
    d: "M7.385 20.539c0-.255.206-.462.461-.462h8.308a.462.462 0 0 1 0 .923H7.846a.46.46 0 0 1-.461-.462",
    clipRule: "evenodd"
  })));
};
export { SvgQMonitorBlack as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMi43NjkyMyIgeT0iMyIgd2lkdGg9IjE4LjQ2MTUiIGhlaWdodD0iMTIuOTIzMSIgcng9IjIiIGZpbGw9IiMwMDA4MUUiLz4KPHBhdGggZD0iTTkuMjMwOCAxNy4wMjkxVjE1LjkyMzFIMTQuNzY5M1YxNy4wMjkxQzE0Ljc2OTMgMTguNjczNSAxNS42MjMyIDE5LjEyMDIgMTYuNTA5NyAyMC4zODM5QzE2LjU1NTYgMjAuNDQ5MyAxNi41MDg0IDIwLjUzODQgMTYuNDI4NiAyMC41Mzg0SDcuNTcxNUM3LjQ5MTYzIDIwLjUzODQgNy40NDQ0OCAyMC40NDkzIDcuNDkwMzUgMjAuMzgzOUM4LjM3Njg4IDE5LjEyMDIgOS4yMzA4IDE4LjY3MzUgOS4yMzA4IDE3LjAyOTFaIiBmaWxsPSIjOUI5QjlCIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNy4zODQ2NCAyMC41Mzg1QzcuMzg0NjQgMjAuMjgzNiA3LjU5MTI4IDIwLjA3NjkgNy44NDYxOCAyMC4wNzY5SDE2LjE1MzlDMTYuNDA4OCAyMC4wNzY5IDE2LjYxNTQgMjAuMjgzNiAxNi42MTU0IDIwLjUzODVDMTYuNjE1NCAyMC43OTM0IDE2LjQwODggMjEgMTYuMTUzOSAyMUg3Ljg0NjE4QzcuNTkxMjggMjEgNy4zODQ2NCAyMC43OTM0IDcuMzg0NjQgMjAuNTM4NVoiIGZpbGw9IiMwMDA4MUUiLz4KPC9zdmc+Cg==";